/*
  Mobile carousels for ingredients and benefits: lets mouse users drag. Touch swiping is native CSS scroll.
*/
(function () {
  var SELECTORS = [
    '.section-ingredients .ingredients-grid',
    '.block-row:has(.block-column--bg) .block-column:not(.block-column--bg) > div'
  ];
  var mq = window.matchMedia('(max-width: 749px)');

  function slides(track) {
    return Array.prototype.filter.call(track.children, function (c) { return c.offsetWidth > 0; });
  }
  function setup(track) {
    if (track.dataset.mxCar) return;
    track.dataset.mxCar = '1';
    track.classList.add('mx-car-track');
    function step() { var s = slides(track); return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : track.clientWidth; }
    function index() { return Math.round(track.scrollLeft / step()); }

    // Mouse drag (touch uses native scrolling)
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
      track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      track.classList.remove('is-dragging');
      if (moved) { var i = index(); track.scrollTo({ left: i * step(), behavior: 'smooth' }); }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
  function init() {
    if (!mq.matches) return;
    SELECTORS.forEach(function (sel) {
      try { document.querySelectorAll(sel).forEach(setup); } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  mq.addEventListener ? mq.addEventListener('change', init) : mq.addListener(init);
  document.addEventListener('shopify:section:load', init);
})();
